import { styled, Tabs, Tab } from "@mui/material";

import { palette } from "~frontend/theme";

export const StyledTabs = styled(Tabs)({
  backgroundColor: palette.lightestGray,
  "& .MuiTabs-indicator": {
    backgroundColor: palette.navy,
    top: 0,
    height: "4px",
  },
});

export const StyledTab = styled(Tab)({
  backgroundColor: palette.midGray,
  color: palette.darkGray,
  flexDirection: "row",

  marginTop: "4px",
  ":not(:last-child)": {
    marginRight: "4px",
  },

  "&.Mui-selected": {
    backgroundColor: palette.lightGray,
    color: palette.navy,
    marginBottom: 0,
  },
});
